module.exports = __webpack_public_path__ + "img/dragonFruit.48a4b49c.png";